import {
  PageStyle,
  ButtonStyle,
  Button,
  ClientDashboard,
  Checkbox,
  Form,
  Formik,
  FormikControl,
  Image,
  useEffect,
  useRouter,
  useState,
  clearSWRCache,
  SelectJobModalAction,
  ErrorPages,
  useSWR,
  CONSTANTS,
  Loading,
  InputError,
  useRef,
  components,
  Tooltip,
} from "@/imports-files/components/model/select-job-modal";
import ModalStyle from "@/styles/components/modal/import-scorecard/_index.module.scss";
import { ScorecardImportAction } from "@/actions/components/scorecard-import";
import {
  Yup,
  TRANSLATION,
} from "@/imports-files/components/model/select-job-modal";
import Modal from "../common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/review-email";

export function ScorecardImportModal(props) {
  const { zeroTemplate, isImported, job_id } = props;
  const [apiError, setApiError] = useState(null);
  const router = useRouter();
  const errorPages = new ErrorPages();
  const [initialValues, setInitialValues] = useState({ template_id: "" });
  const [isLoading, setLoading] = useState(true);
  const [flagForRerender, setFlagForRerender] = useState(0);
  const [options, setOptions] = useState({});
  const scorecardImportAction = new ScorecardImportAction({
    setApiError: setApiError,
    router: router,
  });

  function getTemplateValidationSchema() {
    return Yup.object().shape({
      template_id: Yup.string().required(TRANSLATION("common:errors:required")),
    });
  }

  return props.scoreCardImport ? (
      <Modal
        type="form"
        heading="Import Scorecard"
        closeModal = {()=> props.setScoreCardImport(false)}
       content={
          <Formik
            initialValues={initialValues}
            validationSchema={getTemplateValidationSchema()}
            onSubmit={async (values) => {
              if (isImported) {
                await props.setScoreCardImport(false);
                await props.setIsConfirmation({
                  state: true,
                  scorecardImportAction: scorecardImportAction,
                  job_id: props.job_id,
                  template_id: values.template_id,
                });
              } else {
                let new_values = await scorecardImportAction.submitForm(
                  props.job_id,
                  values.template_id
                );
                if (new_values)
                  await props.formRef.current.setValues(
                    props.scorecardAction.getInitialValue(new_values)
                  );
                if (new_values) await props.formRef.current.resetForm();
                props.setScoreCardImport(false);
              }
            }}
          >
            {(formik) => (
              <Form>
                {zeroTemplate ? (
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <h4
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Description}`}
                    >
                      {"You have not created any scorecard templates yet."}
                    </h4>
                  </div>
                ) : (
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block}`}
                  >
                    <label
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                    >
                      Scorecard Templates
                    </label>
                    <FormikControl
                      className={`${PageStyle.Form__CustomSelect}`}
                      control={"asyncSelect"}
                      formik={formik}
                      placeholder={"Select Template"}
                      loadOptions={async (string) => {
                        let optionsList =
                          await scorecardImportAction.loadTemplateList(string);
                        return optionsList;
                      }}
                      default={formik.values.template_id}
                      name={`template_id`}
                      custom_class={"form_custom_error"}
                      onChange={(option) => {
                        formik.setFieldValue("template_id", option.value);
                      }}
                      style={InputError(formik, `template_id`)}
                    />
                 </div>
                )}
                <div className={FormModalStyle.Modal__Container__ButtonSection}>
                    {zeroTemplate ? (
                      <Button
                        buttonstyle={PageStyle.primarybtn}
                        type="button"
                        onClick={() =>
                          scorecardImportAction.redirectToCreateTemplate(job_id)
                        }
                      >
                        Create Template
                      </Button>
                    ) : (
                      <Button buttonstyle={PageStyle.primarybtn} type="submit">
                        Import
                      </Button>
                    )}
                </div>
              </Form>
            )}
          </Formik>
        }
      />
  ) : (
    ""
  );
}

export function GroupHeading(props) {
  return (
    <div>
      <components.GroupHeading {...props} />
    </div>
  );
}
